"use client";

import { Caveat } from "next/font/google";
import "./marketing.css";
import Preloader from "./sections/Preloader";
import MarketingNav from "./sections/MarketingNav";
import HeroSection from "./sections/HeroSection";
import ScrollTransformation from "./sections/ScrollTransformation";
import GallerySection from "./sections/GallerySection";
import PlatformsSection from "./sections/PlatformsSection";
import TestimonialsSection from "./sections/TestimonialsSection";
import PricingSection from "./sections/PricingSection";
import FaqSection from "./sections/FaqSection";
import FinalCta from "./sections/FinalCta";
import FooterSection from "./sections/FooterSection";

const caveat = Caveat({
  variable: "--font-hand",
  subsets: ["latin"],
  display: "swap",
});

export default function MarketingPage() {
  return (
    <div
      className={`${caveat.variable} marketing-page min-h-screen`}
      style={{ background: "#FDF6EE", color: "#2C2520", overflowX: "clip" }}
    >
      {/* Scroll progress indicator */}
      <div className="mkt-scroll-progress" />

      {/* Grain overlay */}
      <div
        className="pointer-events-none fixed inset-0 z-[9998] opacity-[0.025]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
          backgroundSize: "256px 256px",
        }}
      />

      <Preloader />
      <MarketingNav />
      <HeroSection />
      <ScrollTransformation />
      <GallerySection />
      <PlatformsSection />
      <TestimonialsSection />
      <PricingSection />
      <FaqSection />
      <FinalCta />
      <FooterSection />
    </div>
  );
}
